<div class="mt-6 px-5">
  <ng-container>

    <!-- Section: Servicios populares-->
    <ng-container *ngIf="showPopularServices">
      <div class="mb-8">
        <div class="flex items-center justify-between md:w-[332px]">
          <div class="flex items-center">
            <img src="/assets/images/home/person_support_icon.svg" alt="Nombre" class="mr-2" />
          <h2 class="headline-05">Tus servicios populares</h2>
          </div>
          <div class="flex items-center">
          <!--<span class="left-text">Ver más</span>
          <button mat-icon-button class="left-arrow" aria-label="Atrás">
          <mat-icon>chevron_right</mat-icon>
          </button>-->
          </div>
        </div>
        <p class="subtitle-text">Todo lo necesario para tu salud integral</p>
        <div class="carousel-container">
          <!-- Flecha izquierda -->
          <button
            class="nav-arrow nav-arrow-left"
            (click)="scrollCoberturaLeft()"
            [disabled]="!canScrollCoberturaLeft"
            [class.disabled]="!canScrollCoberturaLeft">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <!-- Contenedor de cards -->
          <div
          class="card-content"
          #coberturaContainer
          (scroll)="onCoberturaScroll($event)">
            <div *ngFor="let service of popularServices" class="card">
              <div class="image-container">
                <img [src]="service.img" alt="Nombre" />
                <div class="detail">
                  <div class="text">
                    <div class="title">{{ service.dsSubServicio }}</div>
                    <div class="subtitle">{{ formatUsage(service.Tomados, service.Disponibles) }} utilizados</div>
                  </div>
                  <mat-icon  (click)="goToSubService(service)"  class="arrow" fontIcon="arrow_circle_right">arrow_circle_right</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Flecha derecha -->
          <button
            class="nav-arrow nav-arrow-right"
            (click)="scrollCoberturaRight()"
            [disabled]="!canScrollCoberturaRight"
            [class.disabled]="!canScrollCoberturaRight">
          <mat-icon>chevron_right</mat-icon>
          </button>

        </div>
      </div>
    </ng-container>

    <!-- Section: Asistencia-->
    <ng-container>
      <div class="mb-8">
        <div class="flex items-center justify-between md:w-[332px]">
          <div class="flex items-center">
            <img src="/assets/images/home/support_icon.svg" alt="Nombre" class="mr-2" />
            <h2 class="headline-05">¿Necesitas asistencia?</h2>
          </div>
          <div class="flex items-center justify-end">
            <!--<span class="left-text">Ver más</span>
            <button mat-icon-button class="left-arrow" aria-label="Atrás">
              <mat-icon>chevron_right</mat-icon>
            </button>-->
          </div>
        </div>
        <p class="subtitle-text">Selecciona qué tipo de asistencia necesitas</p>
        <div class="button-row">
          <div class="button-flex-container">
            <button matFab extended (click)="goToServices(tab.label)" style="cursor: pointer;" *ngFor="let tab of tabs">
              <mat-icon class="tit-icon">{{ tab.icon }}</mat-icon>
              <span>{{ tab.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container>

    </ng-container>

  </ng-container>

</div>

<app-floating-assistance-button></app-floating-assistance-button>
